import { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function StatsSection() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  const stats = [
    { value: '20+', labelKey: 'stats.l1', icon: 'ri-trophy-line' },
    { value: '50+', labelKey: 'stats.l2', icon: 'ri-map-2-line' },
    { value: '20,000+', labelKey: 'stats.l3', icon: 'ri-heart-3-line' },
    { value: '4.9/5', labelKey: 'stats.l4', icon: 'ri-star-fill' },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/13a41c12994cfd48ad6c1b0f215ef8ed.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-emerald-900/85"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className={`text-center mb-12 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-amber-400 font-semibold text-sm uppercase tracking-widest mb-3">{t('stats.badge')}</p>
          <h2 className="text-4xl font-bold text-white font-playfair">
            {t('stats.title')}
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, idx) => (
            <div
              key={stat.labelKey}
              className={`text-center transition-all duration-700 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-amber-500/20 rounded-full mx-auto mb-4 border border-amber-400/30">
                <i className={`${stat.icon} text-2xl text-amber-400`}></i>
              </div>
              <p className="text-4xl font-bold text-white font-playfair mb-2">{stat.value}</p>
              <p className="text-emerald-200/80 text-sm">{t(stat.labelKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
